module.exports = __webpack_public_path__ + "static/media/6_a1.df25bec8.png";